import AuthMiddleware from "@/middleware/auth";

export default [
  {
    path: "/new/medias",
    name: "new.medias",
    component: () => import(/* webpackChunkName: "media" */ "../views/NewMedias"),
    props: true,
    meta: {
      layout: "default",
      middleware: [AuthMiddleware],
      title: "Mídias",
      containerStyle: { height: "100%" },
    },
  },
  {
    path: "/media/create",
    name: "media.create",
    component: () => import(/* webpackChunkName: "media" */ "../views/NewMediaForm"),
    props: true,
    meta: {
      layout: "blank",
      middleware: [AuthMiddleware],
      title: "Criação de mídia",
      guards: ["acl"],
      slug: "media.create",
    },
  },
  {
    path: "/media/show/:id",
    name: "media.view",
    component: () => import(/* webpackChunkName: "media" */ "../views/NewMedia"),
    props: true,
    meta: {
      layout: "default",
      middleware: [AuthMiddleware],
      title: "Mídia",
      containerStyle: { height: "100%" },

    }
  },
  {
    path: "/media/:id/edit",
    name: "media.edit",
    component: () => import(/* webpackChunkName: "media" */ "../views/NewMediaForm"),
    props: true,
    meta: {
      layout: "blank",
      middleware: [AuthMiddleware],
      title: "Edição de mídia",
      guards: ["acl"],
      slug: "media.edit",
    },
  },
  {
    path: "/",
    name: "feed",
    component: () => import(/* webpackChunkName: "feed" */ "../views/Search.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Meu Feed",
    },
  },
  {
    path: "/feed/:mediaType",
    name: "feed.content",
    props: true,
    component: () => import(/* webpackChunkName: "feed" */ "../views/Search.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Conteúdo",
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import(/* webpackChunkName: "feed" */ "../views/Search.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Resultado de Busca",
    },
  },
  {
    path: "/search-filter",
    name: "search-filter",
    component: () => import(/* webpackChunkName: "feed" */ "../views/Search.vue"),
    meta: {
      middleware: [AuthMiddleware],
    },
  },
  {
    path: "/media-collections",
    name: "feed.mediaCollections",
    component: () => import(/* webpackChunkName: "feed" */ "../views/FeedMediaCollections.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Coleção de mídias",
    },
  },
];
